<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-width="120px" class="el-form-title">
      <el-form-item label="任务资源库名称">
        <el-input v-model="form.name" placeholder="请输入需要查询的任务资源库名称" />
      </el-form-item>
      <el-form-item>
        <div class="align-right">
          <el-button @click="fetchData">查询</el-button>
          <el-button @click="addStory">新增</el-button>
        </div>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      height="48"
      border=""
      :header-cell-style="{background:'rgb(244 244 244)'}"
    >
      <el-table-column align="center" label="任务资源库名称" min-width="180" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务状态" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.status_desc }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="问题数量" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.questionNum || 0 }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="描述" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.description || '暂无' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="350" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status !== '1'" @click="delItem(scope.row.id)">删除</el-button>
          <el-button @click="editItem(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status === '4'" @click="reason(scope.row)">失败原因</el-button>
          <el-button v-if="canReExecute(scope.row)" @click="reExecute(scope.row.id)">再次执行</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import { taskBaseList, delTask, executeTask } from '@/api/knowledgeUpload'
import dayjs from 'dayjs'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      listLoading: false,
      form: {
        name: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    reason(val) {
      this.$alert(val.errorMsg, '失败的原因', {
        confirmButtonText: '确定',
        showClose: false
      })
    },
    canReExecute(row) {
      // 状态为失败(4)时可以执行
      if (row.status === '4') {
        return true
      }
      // 状态为执行中(1)且更新时间距离当前超过5分钟时可以执行
      if (row.status === '1' && row.updateTime) {
        const updateTime = dayjs(row.updateTime)
        const now = dayjs()
        const diffMinutes = now.diff(updateTime, 'minute')
        return diffMinutes > 5
      }
      return false
    },
    reExecute(id) {
      this.$confirm('确定要再次执行此任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        executeTask({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '执行成功',
            duration: 2 * 1000
          })
          this.fetchData()
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '执行失败',
            duration: 2 * 1000
          })
        })
      })
    },
    fetchData() {
      this.listLoading = true
      taskBaseList({ page: 1, pageSize: 10, name: this.form.name }).then(response => {
        console.log('res-----', response.data)
        const records = response.data.records || []
        records.forEach(res => {
          res.createTime = dayjs(res.createTime).format('YYYY-MM-DD HH:mm:ss')
          res.updateTime = dayjs(res.updateTime).format('YYYY-MM-DD HH:mm:ss')
          const statusMap = {
            '0': '初始化',
            '1': '执行中',
            '2': '执行成功',
            '4': '执行失败'
          }
          res.status_desc = statusMap[res.status] || ''
        })
        this.list = records
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    addStory() {
      this.$router.push({ name: 'taskBaseDetail' })
    },
    editItem(detail) {
      console.log('scope', detail)
      this.$router.push({ name: 'taskBaseDetail', params: { id: detail.id }})
    },
    delItem(id) {
      this.$confirm('此操作将删除该步骤, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delTask({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
            duration: 2 * 1000
          })
          this.fetchData()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .el-table{
    overflow: auto;
  }
  .el-form-item__content{
    display: flex;
    position: relative;
  }
  .el-button {
    margin-left: 10px;
  }
  .el-button:last-child{
    color: #FFF;
    background-color: #409EFF;
  }
  .el-input__inner {
    width: 400px;
  }
}
// .align-right {
//   position: absolute;
//   right: 0;
// }
.el-form-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>

